import { render } from "./Characters.vue?vue&type=template&id=29bc96b9"
import script from "./Characters.vue?vue&type=script&lang=js"
export * from "./Characters.vue?vue&type=script&lang=js"

import "./Characters.vue?vue&type=style&index=0&id=29bc96b9&lang=scss"

import exportComponent from "/Users/vklosovych/Desktop/vue-exam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__